// extracted by mini-css-extract-plugin
export var avatarContainer = "_3q-1";
export var largeAvatarContainer = "_3q-2";
export var smallAvatarContainer = "_3q-0";